import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policyChangeEffectiveDate: {
        id: 'endorsement.pa.directives.templates.pa-whats-next.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date',
    },
    makeChangesHeader: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.Policy Change Effective Date',
        defaultMessage: 'Make Changes'
    },
    updatePolicyHeader: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.Update policy',
        defaultMessage: 'Update policy'
    },
    effectiveDate: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.Policy Change Effective Date',
        defaultMessage: 'Effective Date',
    },
    tooltipMessage: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.tooltipMessage',
        defaultMessage: 'The effective date must be either today\'s date or a future date. If another change already has been processed on your policy, the effective date for this change cannot be prior to that date and must be at least the day after. Contact us by chat or email if you need a date that is not available.'
    },
    loadingPolicyChange: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.loadingPolicyChange',
        defaultMessage: 'Loading Policy Change',
    },
    selectEffectiveDate: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.selectEffectiveDate',
        defaultMessage: 'Select the effective date for this change',
    },
    initiator: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.initiator',
        defaultMessage: 'Who is initiating this change?',
    },
    nextDescription: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.nextDescription',
        defaultMessage: 'We\'ll gather more {details} next',
    },
    nextDetails: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.nextDetails',
        defaultMessage: 'details about your change',
    },
    oosTransaction: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.oosTransaction',
        defaultMessage: 'This change may be an Out of Sequence transaction',
    },
    oosDate: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.oosDate',
        defaultMessage: 'Another change already exists with a future effective date of {date}.  Please select an effective date after that change.',
    },
    existingChangeBold: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeBold',
        defaultMessage: 'A change is already in progress.',
    },
    existingChangeAmp1: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeAmp1',
        defaultMessage: '{boldText} Effective date has been updated to {date}. If your change is no longer needed, click on ',
    },
    existingChangeAmp2ChatEmail: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeAmp2ChatEmail',
        defaultMessage: 'Contact us by chat or email if you need a date that is not available.',
    },
    existingChangeAmp2: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeAmp2',
        defaultMessage: 'Contact us if you need a date that is not available.',
    },
    existingChangeAmp1NonAdjustedDate: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeAmp1NonAdjustedDate',
        defaultMessage: 'A change is already in progress. Verify the effective date to continue. If your change is no longer needed, click on',
    },
    existingChangeBoldGa: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeBoldGa',
        defaultMessage: 'A change is already started effective',
    },
    existingChangeGA1: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeGA1',
        defaultMessage: '{bold} {date}. Verify date to continue or',
    },
    existingChangeGA2: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeGA2',
        defaultMessage: 'If not needed. Contact Us if date needed is not available.',
    },
    existingChangeGCS: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeGCS',
        defaultMessage: 'If not needed. Contact your resource team if date needed is not available.',
    },
    deleteAllChanges: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.deleteAllChanges',
        defaultMessage: 'DELETE ALL CHANGES',
    },
    discardAllChanges: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.discardAllChanges',
        defaultMessage: 'DISCARD ALL CHANGES',
    },
    deleteConfirmationAlertText1: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.previous transaction discarded: ',
        defaultMessage: 'Previous transaction discarded: '
    },
    deleteConfirmationAlertText2: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.You may continue with the new transaction.',
        defaultMessage: 'You may continue with the new transaction.'
    },
    existingChangeAlert: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.existingChangeAlert',
        defaultMessage: '{msg1} <a>{btnMsg}</a>. {msg2}',
    },
    withdrawingPolicyChange: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.withdrawingPolicyChange',
        defaultMessage: 'Withdrawing Policy Change',
    },
    checkingEffectiveDate: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.checkingEffectiveDate',
        defaultMessage: 'Checking Effective Date',
    },
    transactionRequestedByAgent: {
        id: 'ml.endorsement.pa.directives.templates.pa-whats-next.transactionRequestedByAgent_Ext',
        defaultMessage: 'Is this change requested by an agent?'
    }
});
